<template>
  <div
    class="justify-content-md-center p-3 d-flex flex-column justify-content-between"
    :style="userData.isAndroid ? '' : 'overflow-y: scroll;'"
  >
    <div>
      <!-- Card Infomation -->
      <div
        class="pt-3"
        id="card-infomation"
        style="display: block; margin-top: 16px"
      >
        <span
          class="font-kanit-regular-16 text-kanit-color-black"
          style="display: block"
          >กรุณาเตรียมเอกสารให้ครบถ้วนก่อนอัปโหลด
        </span>
        <span
          class="font-kanit-regular-16 text-kanit-color-black"
          style="display: block"
          >หากคุณปิดหน้านี้ เอกสารของคุณจะไม่ถูกบันทึก</span
        >
        <div class="w-100 border-top-NEXT my-3" />
        <div class="">
          <b-row cols="2" class="mt-1 pt-1">
            <b-col
              class="text-left font-kanit-regular-16 text-align-self-end"
              cols="5"
            >
              <span
                style="vertical-align: baseline"
                class="text-kanit-color-grey"
                >หมายเลขใบสมัคร</span
              >
            </b-col>
            <b-col
              class="text-right font-kanit-regular-16 px-0"
              cols="7"
              style="padding-right: 15px !important"
            >
              <span
                class="font-kanit-regular-16 text-kanit-color-black"
                style="vertical-align: baseline"
                >{{ userData.loanAppId }}</span
              ></b-col
            >
          </b-row>
          <b-row cols="2" class="mt-1" style="line-height: 24px">
            <b-col
              class="text-left font-kanit-regular-16 text-align-self-end px-0"
              style="
                padding-left: 15px !important ;
                line-height: 24px;
                vertical-align: baseline;
              "
              cols="5"
            >
              <span
                style="vertical-align: baseline"
                class="text-kanit-color-grey"
                >อัปโหลดภายในวันที่</span
              >
            </b-col>
            <b-col class="text-right font-kanit-regular-16" cols="7">
              <span
                class="font-kanit-regular-16"
                style="line-height: 24px; vertical-align: baseline"
                >{{ userData.expiredDate }}</span
              ></b-col
            >
          </b-row>
          <b-row cols="2" class="mt-0">
            <template v-if="userData.expireDay != 1">
              <b-col class="text-left" cols="8"> </b-col>
              <b-col class="text-right font-kanit-regular-14 py-1" cols="4">
                <b-row
                  align-h="end"
                  cols="1"
                  class="px-0"
                  style="margin-left: -10px !important ; margin-right: -6px"
                >
                  <b-col
                    class="expired-date-css py-1"
                    :style="
                      userData.expireDay < 10
                        ? 'max-width: 100px !important; padding-left: 8px'
                        : 'max-width: 110px !important; padding-left: 8px'
                    "
                  >
                    <b-img
                      left
                      :src="iconExpireDate"
                      width="20"
                      height="20"
                      style="line-height: 24px"
                    ></b-img>
                    <template v-if="userData.expireDay < 10"> &nbsp;</template>

                    <span
                      class="font-kanit-regular-14"
                      style="line-height: 24px"
                      >อีก {{ userData.expireDay }} วัน</span
                    ></b-col
                  >
                </b-row>
              </b-col>
            </template>
            <template v-else>
              <b-col class="text-left" cols="7"> </b-col>
              <b-col class="text-right font-kanit-regular-14 py-1" cols="5">
                <b-row
                  align-h="end"
                  cols="1"
                  class="px-0"
                  style="margin-left: -7px !important ; margin-right: -6px"
                >
                  <b-col
                    class="expired-date-css py-1"
                    style="max-width: 130px !important; padding-left: 8px"
                  >
                    <b-img
                      left
                      :src="iconExpireDate"
                      width="20"
                      height="20"
                      style="line-height: 24px"
                    ></b-img>

                    <span
                      class="font-kanit-regular-14"
                      style="line-height: 24px"
                      >วันนี้วันสุดท้าย</span
                    ></b-col
                  >
                </b-row>
              </b-col>
            </template>
          </b-row>
        </div>
        <div
          class="w-100 border-top-NEXT"
          style="margin-top: 16px; margin-bottom: 16px"
        />
      </div>
      <!-- Document Required -->
      <div
        id="card-document-list"
        v-if="getDocumentGroupNoDeviate().length > 0"
      >
        <div class="mb-2">
          <span class="font-kanit-bold-16">เอกสารประกอบการสมัคร</span>
        </div>

        <div
          class="mb-3 justify-content-md-center"
          v-for="(item, key) in getDocumentGroupNoDeviate()"
          :key="key"
        >
          <b-card
            class="border-radius-1rem"
            body-class="body-landing py-3"
            @click="goToDocumentGroup(item.grp_id, item.state)"
          >
            <b-row style="line-height: 32px">
              <b-col cols="1" align-self="center">
                <template v-if="item.state == 'attachfile'">
                  <b-img
                    center
                    :src="iconUploadated"
                    width="32"
                    height="32"
                  ></b-img>
                </template>
                <template v-else-if="item.state == 'success'">
                  <b-img
                    center
                    :src="iconUploadsSuccess"
                    width="32"
                    height="32"
                  ></b-img>
                </template>
                <template v-else-if="item.state == 'error'">
                  <b-img
                    center
                    :src="iconUploadsError"
                    width="32"
                    height="32"
                  ></b-img>
                </template>
                <template v-else-if="item.state == 'uploading'">
                  <div class="icon-loader"></div>
                  <b-img
                    center
                    :src="iconUploadated"
                    width="32"
                    height="32"
                  ></b-img>
                </template>
                <template v-else>
                  <b-badge pill class="badge-wait"
                    ><span class="font-kanit-bold-16" style="line-height: 32px">
                      {{ key + 1 }}
                    </span></b-badge
                  >
                </template>
              </b-col>
              <b-col
                class="px-0 text-left"
                col
                style="padding-left: 34px !important"
              >
                <b-row>
                  <b-col
                    col
                    :style="
                      item.state == 'attachfile' || item.state == 'error'
                        ? 'line-height: 1;'
                        : ''
                    "
                  >
                    <span class="font-kanit-regular-16">{{
                      item.grp_name
                    }}</span>
                    <template
                      v-if="item.state == 'attachfile' || item.state == 'error'"
                    >
                      <div class="w-100" />

                      <span
                        class="font-kanit-regular-14"
                        :class="
                          item.state == 'attachfile'
                            ? 'text-kanit-color-blue'
                            : 'text-kanit-color-danger'
                        "
                        >{{
                          item.state == "attachfile"
                            ? "แนบเอกสารแล้ว รอกดอัปโหลด"
                            : "อัปโหลดไม่สำเร็จ กรุณาลองใหม่อีกครั้ง"
                        }}</span
                      >
                    </template>
                  </b-col>
                </b-row>
              </b-col>
              <b-col
                cols="1"
                class="px-0"
                align-self="center"
                style="line-height: 32px; padding-right: 32px !important"
              >
                <b-icon
                  icon="chevron-right"
                  font-scale="1.3"
                  style="color: #838383; margin-bottom: 25%"
                />
              </b-col>
              <template
                v-if="
                  item.state == 'wait' &&
                  'RESUBMIT' === userData.followupStatus.code
                "
              >
                <div class="w-100" />
                <b-col cols="1"></b-col>
                <b-col
                  class="mx-0 px-0"
                  style="margin-top: -10px; padding-left: 34px !important"
                  ><span
                    class="font-kanit-regular-14 text-kanit-color-orange py-1"
                    >{{ "ขอเอกสารเพิ่มเติม" }}</span
                  ></b-col
                >
                <b-col cols="1"></b-col>
              </template>
            </b-row>
            <!-- <div v-if="item.progress > 0" class="mt-2">
                <b-progress
                  class="progress-bar-custom"
                  v-if="item.progress > 0"
                  :value="item.progress"
                  max="100"
                ></b-progress>
              </div> -->
          </b-card>
        </div>
      </div>
      <!-- Document Deviate -->
      <div
        class="mt-4"
        id="card-document-deviate-list"
        v-if="
          getDocumentGroupDeviate().length > 0 &&
          checkDisplayGroupDeviateLength()
        "
      >
        <div class="mb-4">
          <span class="font-kanit-bold-16">เอกสารเพิ่มเติม</span>
        </div>
        <div
          class="mb-3 justify-content-md-center"
          v-for="(item, key) in getDocumentGroupDeviate()"
          :key="key"
        >
          <b-card
            v-if="checkDisplayGroupDeviate(item)"
            class="border-radius-1rem"
            body-class="body-landing py-3"
            @click="goToDocumentGroup(item.grp_id, item.state)"
          >
            <b-row align-content="center" style="line-height: 32px">
              <b-col cols="1" align-self="center">
                <template v-if="item.state == 'attachfile'">
                  <b-img
                    center
                    :src="iconUploadated"
                    width="32"
                    height="32"
                  ></b-img>
                </template>
                <template v-else-if="item.state == 'success'">
                  <b-img
                    center
                    :src="iconUploadsSuccess"
                    width="32"
                    height="32"
                  ></b-img>
                </template>
                <template v-else-if="item.state == 'error'">
                  <b-img
                    center
                    :src="iconUploadsError"
                    width="32"
                    height="32"
                  ></b-img>
                </template>
                <template v-else-if="item.state == 'uploading'">
                  <div class="icon-loader"></div>
                  <b-img
                    center
                    :src="iconUploadated"
                    width="32"
                    height="32"
                  ></b-img>
                </template>
                <template v-else>
                  <b-badge pill class="badge-wait"
                    ><span class="font-kanit-bold-16" style="line-height: 32px">
                      {{ key + 1 + getDocumentGroupNoDeviate().length }}
                    </span></b-badge
                  >
                </template>
              </b-col>
              <b-col
                class="px-0 text-left"
                col
                style="padding-left: 34px !important"
              >
                <b-row>
                  <b-col
                    col
                    :style="
                      item.state == 'attachfile' || item.state == 'error'
                        ? 'line-height: 1;'
                        : ''
                    "
                  >
                    <span class="font-kanit-regular-16">{{
                      item.grp_name
                    }}</span>
                    <template
                      v-if="item.state == 'attachfile' || item.state == 'error'"
                    >
                      <div class="w-100" />

                      <span
                        class="font-kanit-regular-14"
                        :class="
                          item.state == 'attachfile'
                            ? 'text-kanit-color-blue'
                            : 'text-kanit-color-danger'
                        "
                        >{{
                          item.state == "attachfile"
                            ? "แนบเอกสารแล้ว รอกดอัปโหลด"
                            : "อัปโหลดไม่สำเร็จ กรุณาลองใหม่อีกครั้ง"
                        }}</span
                      >
                    </template>
                  </b-col>
                </b-row>
              </b-col>
              <b-col
                cols="1"
                class="px-0"
                align-self="center"
                style="line-height: 32px; padding-right: 32px !important"
              >
                <b-icon
                  icon="chevron-right"
                  font-scale="1.3"
                  style="color: #838383; margin-bottom: 25%"
                />
              </b-col>
              <template
                v-if="
                  item.state == 'wait' &&
                  'RESUBMIT' === userData.followupStatus.code
                "
              >
                <div class="w-100" />
                <b-col cols="1"></b-col>
                <b-col
                  class="mx-0 px-0"
                  style="margin-top: -10px; padding-left: 34px !important"
                  ><span
                    class="font-kanit-regular-14 text-kanit-color-orange py-1"
                    >{{ "ขอเอกสารเพิ่มเติม" }}</span
                  ></b-col
                >
                <b-col cols="1"></b-col>
              </template>
            </b-row>
            <!-- <div v-if="item.progress > 0" class="mt-2">
                <b-progress
                  class="progress-bar-custom"
                  v-if="item.progress > 0"
                  :value="item.progress"
                  max="100"
                ></b-progress>
              </div> -->
          </b-card>
        </div>
      </div>
    </div>
    <!-- Btn action -->
    <div>
      <div v-if="showSubmited()">
        <b-row class="my-3" v-if="updateRender">
          <b-col>
            <button
              @click="doSubmit()"
              :class="
                'btn btn-block btn-submit-landing-page' +
                (isUpload ? ' btn-loading' : '')
              "
              type="button"
              style="line-height: 27px"
              :disabled="!validateState()"
            >
              <span v-if="isUpload">กำลังอัปโหลดเอกสาร</span>
              <span v-else-if="firstSubmit()">อัปโหลดเอกสาร</span>
              <span v-else>อัปโหลดอีกครั้ง</span>
            </button>
          </b-col>
        </b-row>
      </div>
    </div>

    <b-modal
      id="bv-modal-error"
      v-model="modalShow"
      hide-header
      hide-header-close
      hide-footer
      content-class="modal-content-custom"
    >
      <div class="justify-content-center text-center">
        <b-row class="justify-content-md-center">
          <b-col class="py-4"
            ><span class="text-ktb-bold-20">{{
              errorDialogHeader
            }}</span></b-col
          >
          <div class="w-100" />
          <b-col>
            <b-img-lazy
              :src="errorDialogImage"
              width="240"
              height="168"
              center
            ></b-img-lazy
          ></b-col>

          <div class="w-100 py-2" />

          <b-col
            ><span class="text-ktb-bold-20">{{ errorDialogTitle }}</span></b-col
          >
          <div class="w-100 py-2" />
          <b-col class="font-kanit-regular-16-16-grey">{{
            errorDialogMessage
          }}</b-col>
          <div class="w-100" style="margin-top: 95%" />
          <b-col>
            <button
              :class="
                'btn btn-info rounded-pill btn-block font-weight-bold btn-ktb btn-ktb-gradient btn-ktb-' +
                userData.channel
              "
              type="button"
              style="line-height: 20px"
              @click="$bvModal.hide('bv-modal-error')"
            >
              <b style="color: white">ตกลง</b>
            </button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      imgSwalErr: require("@/assets/images/ic_swal_error_reject.png"),
      imgArrowRight: require("@/assets/images/ic_landing_nevigate.png"),
      iconUploadsError: require("@/assets/images/ic_landing_error.png"),
      iconUploadsSuccess: require("@/assets/images/ic_landing_success.png"),
      iconUploading: require("@/assets/images/foundationIconSimpleComponentSnackbarUpload.png"),
      iconUploadated: require("@/assets/images/ic_landing_uploaded.png"),
      imgArrowNone: require("@/assets/images/ic_landing_nevigate.png"),
      iconExpireDate: require("@/assets/images/ic_pending.png"),
      documentGroup: {},
      axiosInstance: null,
      timeout: parseInt(process.env.VUE_APP_TIMEOUT),
      maxsize: parseInt(process.env.VUE_APP_MAXSIZE),
      user: {},
      isUpload: false,
      updateRender: 1,
      countDocTypeUploading: 0,
      countDocTypeAttachfile: 0,
      urlapi: process.env.VUE_APP_APIURL,
      groupRequire: [],
      groupDeviate: [],
      docList: [],
      modalShow: false,
      errorDialogTitle: "",
      errorDialogMessage: "",
      errorDialogHeader: "",
      errorDialogImage: null,
    };
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
    getHeight() {
      return window.innerHeight - 45;
    },
  },
  created() {
    try {
      this.$callback.enterFullScreen();
    } catch (err) {
      //console.error(err);
    }
    let currentMenu = {
      pageCode: "CommonLanding",
      pageName: "อัปโหลดเอกสาร",
      previousPage: "",
    };
    this.$event.$emit("update_current_menu", currentMenu);
    this.documentGroup = this.userData.document_group_type;
    this.documentType = this.userData.documentType;
    for (let item of this.documentGroup) {
      if (item.state == "wait" || item.state == "addDocument") {
        item.state = this.setStateGroupDocument(item.grp_id);
      }
      if (
        item.grp_id === "01" &&
        item.state != "success" &&
        item.state != "error"
      ) {
        item.state = this.setStateGroupDocument(item.grp_id);
      }
      if (item.lst_doc_id.length > 1) {
        this.checkStateDocumentGroup(item);
      }
    }
    const fnSet = this.setIsLoading;
    const timeoutAxios = this.timeout;
    this.axiosInstance = axios.create({
      baseURL: this.urlapi,
      headers: { Authorization: this.userData.token },
    });
    this.axiosInstance.interceptors.request.use(
      function (config) {
        config.timeout = timeoutAxios;
        fnSet(true);
        return config;
      },
      function (error) {
        console.log("request error", error);
        fnSet(false);
        // Do something with request error
        return Promise.reject(error);
      }
    );
    this.axiosInstance.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        console.log("response error", error);
        fnSet(false);
        if (
          error.code === "ECONNABORTED" &&
          error.message.includes("timeout")
        ) {
          console.log("Request timed out");
        }
        return Promise.reject(error);
      }
    );
    this.mappingGroup();

    window.onMobileBackPressed = function () {
      console.log("onMobileBackPressed");

      this.$callback.openLfmStatusPage();

      return true;
    };
  },
  methods: {
    mappingGroup() {
      this.documentGroup.filter((item) => {
        let found = false;
        item.lst_doc_id.forEach((d) => {
          const data = this.documentType.find(
            (e) => e.doc_code == d && !e.deviate_flag
          );
          if (data !== undefined) found = true;
        });
        if (found) {
          this.groupRequire.push(item);
        } else {
          this.groupDeviate.push(item);
        }
      });
    },
    setIsLoading(value) {
      this.isUpload = value;
    },
    getDocumentGroup() {
      return this.documentGroup;
    },
    getDocumentType() {
      return this.documentType;
    },
    getDocumentGroupNoDeviate() {
      return this.groupRequire;
    },
    getDocumentGroupDeviate() {
      return this.groupDeviate;
    },
    getDocumentTypeIsRequire() {
      return this.documentType.filter((item) => !item.deviate_flag);
    },
    getDocumentTypeIsDeviate() {
      return this.documentType.filter((item) => item.deviate_flag);
    },
    checkDocTypeIsSuccess(grpId, state) {
      if (this.firstSubmit()) return false;
      if ("01" === grpId && state !== "error") {
        let attachfile = this.checkDocument(grpId);
        let dStatement =
          this.userData.dStatementSelected != undefined &&
          this.userData.dStatementSelected;
        let ktbStatement =
          this.userData.accountSelected != undefined &&
          this.userData.accountSelected != "";

        if (attachfile || dStatement || ktbStatement) {
          return true;
        } else {
          return false;
        }
      }

      return state === "success";
    },
    goToDocumentGroup(grpId, state) {
      //check success
      if (this.checkDocTypeIsSuccess(grpId, state)) {
        console.log("docType state : " + state);
      }
      this.userData.grpId = grpId;
      this.$store.dispatch("setUserData", this.userData);
      let docList = [];
      this.listDoc = this.userData.document_group_type.find(
        (v) => v.grp_id == grpId
      );

      for (var i = 0; i < this.listDoc.lst_doc_id.length; i++) {
        for (var j = 0; j < this.userData.documentType.length; j++) {
          if (
            this.userData.documentType[j].doc_code == this.listDoc.lst_doc_id[i]
          ) {
            docList.push(this.userData.documentType[j]);
          }
        }
      }
      if (process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT == grpId) {
        this.$router.push({
          name: this.userData.routerPath.documentGroup,
          params: { grpId: grpId, action: "NEXT" },
        });
      } else if (docList.length == 1 && docList[0].state != "deviate") {
        this.goToUploadPage(docList[0].doc_code, grpId);
      } else {
        this.$router.push({
          name: this.userData.routerPath.documentGroup,
          params: { grpId: grpId, action: "NEXT" },
        });
      }
    },
    logout() {
      sessionStorage.clear();
      this.$store.dispatch("clearUserData");
      this.$router.push({
        name: this.userData.routerPath.login,
      });
    },
    showSubmited() {
      return ["PENDING", "SUBMITED", "RESUBMIT"].includes(
        this.userData.followupStatus.code
      );
    },
    checkDocument(grpId) {
      let docGroup = this.userData.document_group_type.find(
        (v) => v.grp_id == grpId
      );
      return (
        this.userData.documentType.filter(
          (docType) =>
            docGroup.lst_doc_id.includes(docType.doc_code) &&
            docType.filesReal.length > 0
        ).length > 0
      );
    },
    setStateGroupDocument(grp_id) {
      let state;
      if (this.checkDocument(grp_id)) {
        state = "attachfile";
      } else {
        state = "wait";
      }
      if ("01" === grp_id) {
        let attachfile = this.checkDocument(grp_id);
        let dStatement =
          this.userData.dStatementSelected != undefined &&
          this.userData.dStatementSelected;
        let ktbStatement =
          this.userData.accountSelected != undefined &&
          this.userData.accountSelected != "";

        if (attachfile || dStatement || ktbStatement) {
          state = "attachfile";
        } else {
          state = "wait";
        }
      }

      //if error
      let docGroup = this.userData.document_group_type.find(
        (v) => v.grp_id == grp_id
      );
      if (
        this.userData.documentType.filter(
          (docType) =>
            docGroup.lst_doc_id.includes(docType.doc_code) &&
            docType.state == "error"
        ).length > 0
      ) {
        state = "error";
      }

      return state;
    },
    async doSubmit() {
      try {
        if (this.validateState()) {
          this.checkTimeOut().then(() => {
            if (this.$swal.isVisible()) return;
            this.doSubmitImageProcessing();
          });
        } else {
          this.getAlert("2001");
        }
      } catch (err) {
        console.error(err);
        this.getAlert("9999");
      }
    },
    firstSubmit() {
      let success = this.documentGroup.filter((i) => i.state == "success");
      let error = this.documentGroup.filter((i) => i.state == "error");
      return success.length == 0 && error.length == 0;
    },
    validateState() {
      //return false = disabled
      //return true = not disabled
      if (this.documentGroup.filter((i) => i.state == "error").length > 0)
        return false;
      let attachfileRequire = this.getDocumentType().filter(
        (i) =>
          (i.state == "attachfile" || i.state == "success") && !i.deviate_flag
      );
      let checkStatement = 0;
      if (this.firstSubmit()) {
        for (let item of this.documentGroup) {
          if (item.grp_id === "01") {
            let docCode = item.lst_doc_id[0];
            let docType = this.getDocumentType().find(
              (v) => v.doc_code == docCode
            );
            if (
              ((this.userData.dStatementSelected != undefined &&
                this.userData.dStatementSelected) ||
                (this.userData.accountSelected != undefined &&
                  this.userData.accountSelected != "")) &&
              (docType.filesReal == 0 || docType.filesReal === undefined)
            ) {
              checkStatement = 1;
              break;
            }
          }
        }
        if (
          attachfileRequire.length <
          this.getDocumentTypeIsRequire().length - checkStatement
        ) {
          return false;
        }
      } else {
        let attachfileRequireSecondSubmit = this.getDocumentType().filter(
          (i) => !i.deviate_flag
        ).length;
        let attachfileRequireSecond = this.getDocumentType().filter(
          (i) => i.state == "attachfile" && !i.deviate_flag
        );
        let countSuccess = this.getDocumentTypeIsRequire().filter(
          (i) => i.state == "success"
        ).length;
        let document_group_type = this.userData.document_group_type.find(
          (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
        );
        if (document_group_type !== undefined) {
          let docCode = document_group_type.lst_doc_id[0];
          let docType = this.userData.documentType.find(
            (v) => v.doc_code == docCode
          );
          if (
            ((this.userData.dStatementSelected != undefined &&
              this.userData.dStatementSelected) ||
              (this.userData.accountSelected != undefined &&
                this.userData.accountSelected != "")) &&
            (docType.filesReal == 0 || docType.filesReal === undefined)
          ) {
            checkStatement = 1;
          }
        }
        if (checkStatement == 1) {
          if (attachfileRequireSecondSubmit > countSuccess + checkStatement) {
            return false;
          }
        } else {
          if (
            attachfileRequireSecondSubmit >
            countSuccess + attachfileRequireSecond.length
          ) {
            return false;
          }
        }
      }

      return true;
    },
    async doSubmitImageProcessing() {
      let uploaded = false;
      this.updateRender += 1;
      this.countDocTypeUploading = 0;
      this.countDocTypeAttachfile = 0;
      this.documentGroup
        .filter((i) => i.state == "attachfile")
        .forEach((item) => {
          this.$set(item, "state", "uploading");
        });
      this.countDocTypeUploading = this.userData.documentType.filter(
        (docType) => docType.state == "attachfile"
      ).length;
      this.countDocTypeAttachfile = this.userData.documentType.filter(
        (docType) => docType.state == "wait"
      ).length;
      const totalDocDeviate = this.userData.documentType.filter(
        (docType) => docType.deviate_flag
      ).length;
      this.$forceUpdate();
      try {
        for (
          let docGroupItem = 0;
          docGroupItem < this.userData.document_group_type.length;
          docGroupItem++
        ) {
          if (
            this.userData.document_group_type[docGroupItem].state == "uploading"
          ) {
            let array = this.userData.documentType.filter((docType) =>
              this.userData.document_group_type[
                docGroupItem
              ].lst_doc_id.includes(docType.doc_code)
            );

            for (let docTypeItem of array) {
              if (
                docTypeItem.state == "attachfile" &&
                docTypeItem.filesReal.length > 0
              ) {
                uploaded = true;

                if (this.modalShow) return;

                if (this.isOtherBanks(docTypeItem)) {
                  const formData = this.getFormOtherStatement(docTypeItem);
                  await this.axiosInstance({
                    method: "POST",
                    url: "api/save",
                    timeout: this.timeout,
                    data: formData,
                  })
                    .catch(() => {
                      docTypeItem.state = "error";
                      this.forceStateDocumentGroup(docTypeItem.doc_code);
                      this.$forceUpdate();
                    })
                    .then((res) => {
                      this.mappingResponseSave(res, docTypeItem);
                    });
                
                } else {
                  const formData = this.getFormData(docTypeItem);
                  await this.axiosInstance({
                    method: "POST",
                    url: "api/save",
                    timeout: this.timeout,
                    data: formData,
                  })
                    .catch(() => {
                      docTypeItem.state = "error";
                      this.forceStateDocumentGroup(docTypeItem.doc_code);
                      this.$forceUpdate();
                    })
                    .then((res) => {
                      this.mappingResponseSave(res, docTypeItem);
                    });
                 
                }
              }
            }

            this.$forceUpdate();
          }
        }
        if (uploaded) return;
        // deviate all
        if (
          this.countDocTypeUploading == 0 &&
          this.countDocTypeAttachfile == totalDocDeviate &&
          !uploaded
        ) {
          this.documentGroup
            .filter((i) => i.state == "wait")
            .forEach((item) => {
              this.$set(item, "state", "success");
            });
          this.$forceUpdate();
          this.triggerSubmit();
          return;
        }
        if (
          this.countDocTypeUploading == 0 &&
          this.userData.documentType.length == 1 &&
          !uploaded &&
          this.checkKtbStatement()
        ) {
          this.documentGroup
            .filter((i) => i.state == "wait")
            .forEach((item) => {
              this.$set(item, "state", "success");
            });
          this.$forceUpdate();
          this.triggerSubmit();
          return;
        }

        //devaite all + ktb-statement
        if (
          totalDocDeviate + (this.checkKtbStatement() ? 1 : 0) ==
          this.userData.documentType.length
        ) {
          this.documentGroup
            .filter((i) => i.state == "wait")
            .forEach((item) => {
              this.$set(item, "state", "success");
            });
          this.$forceUpdate();
          this.triggerSubmit();
          return;
        }
      } catch (error) {
        console.error(error);
        this.getAlert("9999");
      }
    },
    async delay(time) {
      await new Promise((resolve) => setTimeout(resolve, time));
    },
    randomNumber: function () {
      return Math.floor(Math.random() * 30);
    },
    getFormData(docTypeObject) {
      let formData = new FormData();
      let password = [];
      if (docTypeObject.filesReal !== undefined) {
        docTypeObject.filesReal.forEach((f) => {
          if (f.file !== undefined) {
            formData.append(f.type, f.file);
          }
          if (
            !f.fileHavePassword &&
            f.password != undefined &&
            !password.includes(f.file.name + "|" + f.password)
          ) {
            password.push(f.file.name + "|" + f.password);
          }
        });
      }
      formData.append("doc_code", docTypeObject.doc_code);
      if (password.length > 0) formData.append("lst_password", password);
      return formData;
    },
    getFormDeviateData() {
      let grp01 = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      let docIdStatement;
      if (grp01 !== undefined) {
        docIdStatement = grp01.lst_doc_id[0];
      }

      let lstDeviate = [];

      this.userData.documentType.forEach((i) => {
        if (
          i.deviate_flag &&
          (i.filesReal == undefined || i.filesReal.length == 0)
        ) {
          lstDeviate.push(i.doc_code);
          i.state = "deviate";
        }
        if (
          i.doc_code == docIdStatement &&
          (i.filesReal == undefined || i.filesReal.length == 0)
        ) {
          lstDeviate.push(i.doc_code);
          i.state = "success";
        }
      });

      this.$forceUpdate();
      return {
        lstDeviate: lstDeviate,
        accountLst:
          this.userData.accountSelected != undefined
            ? this.userData.accountSelected
            : [],
        dStatementFlag:
          this.userData.dStatementSelected != undefined
            ? this.userData.dStatementSelected
            : false,
        docIdStatement: docIdStatement,
      };
    },
    getFormOtherStatement(docTypeObject) {
      let formData = new FormData();
      let password = [];
      if (docTypeObject.filesReal !== undefined) {
        docTypeObject.filesReal.forEach((f) => {
          if (f.file !== undefined) {
            formData.append(
              docTypeObject.doc_code + "_" + f.uploadType,
              f.file
            );
          }
          if (
            !f.fileHavePassword &&
            f.password != undefined &&
            !password.includes(f.file.name + "|" + f.password)
          ) {
            password.push(f.file.name + "|" + f.password);
          }
        });
      }
      if (password.length > 0) formData.append("lst_password", password);
      return formData;
    },
    async checkTimeOut() {
      let response;
      response = await this.axiosInstance({
        method: "GET",
        url: "api/checkTimeout",
        timeout: this.timeout,
        headers: {
          Authorization: this.userData.token,
        },
      })
        .then((response) => {
          return response;
        })
        .catch((error) => {
          console.log("checkTimeout", error);
          if (this.userData.channel == "WEB") {
            this.$store.dispatch("clearUserData");
          }
          this.handdleError(error);
          return response;
        });
      return response;
    },
    async sendUploads(formData) {
      this.axiosInstance({
        timeout: this.timeout,
        method: "POST",
        url: "api/upload",
        data: formData,
      })
        .then((res) => {
          if (res.data.status) {
            this.userData.followupStatus = res.data.followupStatus;
            this.$store.dispatch("setUserData", this.userData);
            if (this.triggerSubmitOtherBanks()) {
              this.sendOtherbanks(res.data.callDocTum);
            } else {
              this.documentGroup
                .filter((i) => i.state == "uploading")
                .forEach((item) => {
                  this.$set(item, "state", "success");
                });
              this.closeWeb(res.data.callDocTum);
            }
          } else {
            if (
              res.data.errorList !== undefined &&
              res.data.errorList.length > 0
            ) {
              let groupStatement = false;
              res.data.errorList.forEach((doc_error) => {
                this.userData.documentType.forEach((j) => {
                  if (j.doc_code == doc_error.docCode) {
                    this.$set(j, "state", "error");
                    j.filesReal.forEach((file) => {
                      if (doc_error.accountType === file.uploadType)
                        this.$set(file, "state", "error");
                      else if (
                        file.uploadType !== undefined &&
                        file.state !== "error"
                      )
                        this.$set(file, "state", "success");
                    });
                  }
                });
                this.documentGroup.forEach((k) => {
                  if (k.lst_doc_id.includes(doc_error.docCode)) {
                    k.state = "error";
                    if (k.grp_id == "01") groupStatement = true;
                  }
                });
              });

              if (!groupStatement) {
                let document_group_type =
                  this.userData.document_group_type.find(
                    (item) =>
                      item.grp_id ==
                      process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
                  );
                if (document_group_type !== undefined) {
                  let docCode = document_group_type.lst_doc_id[0];
                  let docTypeItem = this.userData.documentType.find(
                    (v) => v.doc_code == docCode
                  );

                  docTypeItem.filesReal.forEach((file) => {
                    this.$set(file, "state", "success");
                  });
                }
              }

              this.$forceUpdate();

              this.documentGroup
                .filter((i) => i.state == "uploading")
                .forEach((item) => {
                  this.$set(item, "state", "success");
                });
            } else {
              this.getAlert(res.data.code);
            }
          }
          this.setIsLoading(false);
        })
        .catch((error) => {
          this.handdleError(error);
        });
    },
    closeWeb(callDocTum) {
      let grp01 = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      let docIdStatement = "";
      if (grp01 !== undefined) {
        docIdStatement = grp01.lst_doc_id[0];
      }
      this.axiosInstance({
        method: "GET",
        url: process.env.VUE_APP_PATH_CLOSE_WEB,
        params: {
          callDocTum: callDocTum,
          dStatementFlag:
            this.userData.dStatementSelected != undefined
              ? this.userData.dStatementSelected
              : false,
          docIdStatement: docIdStatement,
        },
      })
        .then(() => {
          this.setIsLoading(true);
          const fn = this.setIsLoading;

          this.userData.followupStatus = {
            code: "COMPLETE",
            desc: "Pending for Approval",
            name: "คำขออยู่ระหว่างการพิจารณา",
          };
          this.$store.dispatch("setUserData", this.userData);
          this.$forceUpdate();
          try {
            this.$callback.openLfmStatusPage();
          } catch (err) {
            console.error(err);
          }

          setTimeout(function () {
            fn(false);
          }, 10000);
        })
        .catch((error) => {
          this.handdleError(error);
        });
    },
    handdleError(error) {
      console.log("handdleError", error.message);
      this.$forceUpdate();
      this.setIsLoading(false);
      if (error.response) {
        if (
          error.response.data != undefined &&
          error.response.data.code != undefined
        ) {
          this.getAlert(error.response.data.code);
        } else {
          this.getAlert(error.response.status);
        }
      } else if (
        error.message !== undefined &&
        error.message.startsWith("timeout")
      ) {
        this.getAlert("5008");
      } else {
        this.getAlert("9999");
      }
    },
    getAlert(code) {
      this.updateRender += 1;
      this.setIsLoading(false);
      let title = null;
      let detail = null;
      let appIsExpired = false;
      let exitEntryPoint = false;
      let goToLFMStatusPage = false;
      switch (code) {
        case "2001":
          (title = "จำนวนเอกสารไม่ครบเงื่อนไขในการสมัคร"),
            (detail = "กรุณาตรวจสอบเอกสารประกอบการสมัครอีกครั้ง");
          break;
        case "4001":
          title = "ท่านทำรายการไม่ถูกต้อง";
          detail = "กรุณาทำรายการใหม่อีกครั้ง";
          break;
        case "4005":
          title = "หมดเวลาทำรายการ";
          detail = "กรุณาลองใหม่อีกครั้ง";
          goToLFMStatusPage = true;
          break;
        case "4006":
          title = "หมดเวลาทำรายการ";
          detail = "กรุณาลองใหม่อีกครั้ง";
          goToLFMStatusPage = true;
          break;
        case "4007":
          title = "ใบสมัครถูกยกเลิก";
          detail =
            "เนื่องจากคุณทำรายการเกินเวลาที่กำหนด คุณสามารถสมัครสินเชื่อได้อีกครั้งผ่านแอปฯ เป๋าตัง หรือ Krungthai NEXT ขอขอบคุณในความไว้วางใจ และหวังเป็นอย่างยิ่งว่าจะได้ให้บริการคุณในโอกาสต่อไป";
          appIsExpired = true;
          break;
        case "4009":
          title = "หมดเวลาทำรายการ";
          detail = "กรุณาลองใหม่อีกครั้ง";
          goToLFMStatusPage = true;
          break;
        case "5003":
          (title = "ประเภทของไฟล์ไม่ถูกต้อง"),
            (detail = "กรุณาเลือกประเภทของไฟล์ได้แก่ PDF, PNG หรือ JPG");
          break;
        case "5004":
          (title = "ไฟล์มีปัญหา"),
            (detail = "ไม่สามารถเปิดไฟล์ได้ กรุณาลองใหม่อีกครั้ง");
          exitEntryPoint = true;
          break;
        case "5007":
          title = "ไม่สามารถดำเนินการได้ในขณะนี้";
          detail = "กรุณาลองใหม่อีกครั้ง";
          exitEntryPoint = true;
          break;
        case "5008":
          title = "ไม่สามารถดำเนินการได้ในขณะนี้";
          detail = "กรุณาลองใหม่อีกครั้ง(1)";
          exitEntryPoint = true;
          break;
        case "5009":
          title = "ไม่สามารถทำรายการได้ในขณะนี้";
          detail = "กรุณาลองใหม่อีกครั้งในภายหลัง";
          exitEntryPoint = true;
          break;
        default:
          title = "ไม่สามารถทำรายการได้ในขณะนี้(1)";
          detail = "กรุณาลองใหม่อีกครั้งในภายหลัง(1)";
          exitEntryPoint = true;
      }
      if (appIsExpired) {
        this.showAlertThenExitEntryPointIOS(
          this.imgSwalErr,
          title,
          detail,
          "สถานะการสมัคร"
        );
      } else if (exitEntryPoint) {
        this.showAlertThenExitEntryPointIOS(
          this.imgSwalErr,
          title,
          detail,
          "อัปโหลดเอกสาร"
        );
      } else if (goToLFMStatusPage) {
        this.showAlertThenGotoStatusPages(
          this.imgSwalErr,
          title,
          detail,
          "อัปโหลดเอกสาร"
        );
      } else {
        this.showAlert(this.imgSwalErr, title, detail, "อัปโหลดเอกสาร");
      }
    },
    showAlert(img, title, msg, headerTxt) {
      if (this.$swal.isVisible()) return;
      this.$swal
        .fire({
          iconHtml: headerTxt,
          imageUrl: img,
          position: "center",
          title: title,
          text: msg,
          confirmButtonText: "ตกลง",
          confirmButtonColor: "#00A3E4",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          customClass: {
            title:
              "font-kanit-bold-24 text-kanit-color-black dstatement-popup swal2-title-custom",
            confirmButton: "btn btn-block btn-submit-landing-page",
            popup: "swal2-modal-dstatement swal2-modal-next-fullscreen",
            image: "swal2-image-dstatement swal2-image-next-fullscreen",
            htmlContainer:
              "swal2-htmlContainer-next-fullscreen font-kanit-regular-16-16-grey",
            actions: "swal2-actions-next-fullscreen",
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.documentGroup
              .filter((i) => i.state == "uploading")
              .forEach((item) => {
                this.$set(item, "state", "attachfile");
              });
            this.$forceUpdate();
          }
        });
    },
    showAlertThenExitEntryPointIOS(img, title, msg, headerTxt) {
      if (this.$swal.isVisible()) return;
      this.$swal
        .fire({
          iconHtml: headerTxt,
          imageUrl: img,
          position: "center",
          title: title,
          text: msg,
          confirmButtonText: "ตกลง",
          confirmButtonColor: "#00A3E4",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          customClass: {
            title:
              "font-kanit-bold-24 text-kanit-color-black dstatement-popup swal2-title-custom",
            confirmButton: "btn btn-block btn-submit-landing-page",
            popup: "swal2-modal-dstatement swal2-modal-next-fullscreen",
            image: "swal2-image-dstatement swal2-image-next-fullscreen",
            htmlContainer:
              "swal2-htmlContainer-next-fullscreen font-kanit-regular-16-16-grey",
            actions: "swal2-actions-next-fullscreen",
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.documentGroup
              .filter((i) => i.state == "uploading")
              .forEach((item) => {
                this.$set(item, "state", "attachfile");
              });
            this.$forceUpdate();
            try {
              this.$callback.openLFMProductionShelf();
            } catch (err) {
              console.error(err);
            }
          }
        });
    },
    showAlertThenGotoStatusPages(img, title, msg, headerTxt) {
      if (this.$swal.isVisible()) return;
      this.$swal
        .fire({
          iconHtml: headerTxt,
          imageUrl: img,
          position: "center",
          title: title,
          text: msg,
          confirmButtonText: "ตกลง",
          confirmButtonColor: "#00A3E4",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          customClass: {
            title:
              "font-kanit-bold-24 text-kanit-color-black dstatement-popup swal2-title-custom",
            confirmButton: "btn btn-block btn-submit-landing-page",
            popup: "swal2-modal-dstatement swal2-modal-next-fullscreen",
            image: "swal2-image-dstatement swal2-image-next-fullscreen",
            htmlContainer:
              "swal2-htmlContainer-next-fullscreen font-kanit-regular-16-16-grey",
            actions: "swal2-actions-next-fullscreen",
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.documentGroup
              .filter((i) => i.state == "uploading")
              .forEach((item) => {
                this.$set(item, "state", "attachfile");
              });
            this.$forceUpdate();
            try {
              this.$callback.openLfmStatusPage();
            } catch (err) {
              console.error(err);
            }
          }
        });
    },
    triggerSubmit() {
      try {
        this.setStateDocumentGroup();
        if (
          this.getDocumentGroup().filter((d) => d.state == "error").length > 0
        )
          return;
        let data = this.getFormDeviateData();
        this.sendUploads(data);
      } catch (err) {
        console.error(err);
      }
    },
    setStateDocumentGroup() {
      let arrayGroup = this.documentGroup.filter((i) => i.state == "uploading");
      let ListLength = arrayGroup.length;
      let counting = 0;
      arrayGroup.forEach((docGroup) => {
        counting++;
        if (ListLength == counting) {
          docGroup.state = "uploading";
        } else {
          let array = this.userData.documentType.filter(
            (docType) =>
              docGroup.lst_doc_id.includes(docType.doc_code) &&
              docType.state == "error"
          );
          if (array.length == 0) {
            // docGroup.state = "success";
            docGroup.state = "uploading";
          } else {
            docGroup.state = "error";
            docGroup.errorMsg = "อัปโหลดไม่สำเร็จ กรุณาลองใหม่อีกครั้ง";
          }
        }
      });
      this.$forceUpdate();
    },
    forceStateDocumentGroup(docCode) {
      let arrayGroup = this.documentGroup.filter(
        (i) => i.state == "uploading" && i.lst_doc_id.includes(docCode)
      );
      arrayGroup.forEach((docGroup) => {
        let array = this.userData.documentType.filter(
          (docType) =>
            docGroup.lst_doc_id.includes(docType.doc_code) &&
            docType.state == "error"
        );
        if (array.length == 0) {
          docGroup.state = "success";
        } else {
          docGroup.state = "error";
          docGroup.errorMsg = "อัปโหลดไม่สำเร็จ กรุณาลองใหม่อีกครั้ง";
        }
      });
      this.$forceUpdate();
    },
    checkDisplayGroupDeviate(item) {
      if (this.firstSubmit()) return true;
      if (
        item.state == "success" ||
        item.state == "error" ||
        item.state == "attachfile" ||
        item.state == "uploading"
      )
        return true;
      return false;
    },
    checkDisplayGroupDeviateLength() {
      let count = 0;
      if (this.firstSubmit()) return true;
      this.getDocumentGroupDeviate().forEach((item) => {
        if (
          item.state == "success" ||
          item.state == "error" ||
          item.state == "attachfile" ||
          item.state == "uploading"
        )
          count++;
      });
      return count > 0;
    },
    goToUploadPage(doc_code, grpId) {
      this.$router.push({
        name: this.userData.routerPath.upload,
        params: { doc_code: doc_code, grpId: grpId },
      });
    },
    checkKtbStatement() {
      let grp01 = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );

      let docIdStatement;
      if (grp01 !== undefined) {
        docIdStatement = grp01.lst_doc_id[0];
        return (
          docIdStatement !== undefined &&
          (this.userData.accountSelected != undefined ||
            this.userData.dStatementSelected != undefined)
        );
      } else {
        return false;
      }
    },
    calcHeight() {
      var h = window.innerHeight;
      return h < 680;
    },
    checkStateDocumentGroup(documentGroup) {
      if (documentGroup.state == "success") return;
      var isError = false;
      //someone doctype = fail
      documentGroup.lst_doc_id.forEach((d) => {
        const data = this.documentType.find((e) => e.doc_code == d);

        if (data !== undefined && data.state == "error") {
          isError = true;
        }
      });

      if (isError) {
        documentGroup.state = "error";
        return;
      }
      let attachComplete = false;
      let isDocRequire = false;
      documentGroup.lst_doc_id.forEach((d) => {
        const data = this.documentType.find(
          (e) => e.doc_code == d && !e.deviate_flag
        );
        if (data !== undefined) {
          if (!isDocRequire) isDocRequire = true;
        }
      });
      if (isDocRequire) {
        let countComplete = 0;
        let countTotalRequire = 0;
        documentGroup.lst_doc_id.forEach((d) => {
          const data = this.documentType.find(
            (e) => e.doc_code == d && !e.deviate_flag
          );

          if (data !== undefined) {
            countTotalRequire++;
          }

          if (
            data !== undefined &&
            data.filesReal != undefined &&
            data.filesReal.length > 0
          ) {
            countComplete++;
          }
        });

        if (countComplete == countTotalRequire) attachComplete = true;
      } else {
        documentGroup.lst_doc_id.forEach((d) => {
          const data = this.documentType.find((e) => e.doc_code == d);
          if (
            data !== undefined &&
            data.filesReal != undefined &&
            data.filesReal.length > 0
          ) {
            if (!attachComplete) attachComplete = true;
          }
        });
      }

      documentGroup.state = attachComplete ? "attachfile" : "wait";
    },
    mappingResponseSave(res, docTypeItem) {
      try {
        if (res.data.status == "SUCCESS") {
          this.countDocTypeUploading = this.countDocTypeUploading - 1;
          docTypeItem.state = "success";
        } else if (res.data.status == "FAIL") {

          for (let item of docTypeItem.filesReal) {
            for (let err of res.data.errorDetail) {
              if(err.accountType !== undefined && err.accountType === item.uploadType){
                item.state = "error";
              }       
            }
          }
          docTypeItem.state = "error";
          this.forceStateDocumentGroup(docTypeItem.doc_code);
        }
        this.$forceUpdate();
        if (this.countDocTypeUploading == 0) {
          this.triggerSubmit();
        }
      } catch (e) {
        docTypeItem.state = "error";
        this.forceStateDocumentGroup(docTypeItem.doc_code);
        this.$forceUpdate();
      }
    },
    triggerSubmitOtherBanks() {
      let document_group_type = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      if (document_group_type !== undefined) {
        let docCode = document_group_type.lst_doc_id[0];
        let docTypeItem = this.userData.documentType.find(
          (v) => v.doc_code == docCode
        );
        if (
          docTypeItem.filesReal.length > 0 &&
          docTypeItem.filesReal.filter((file) => file.uploadType !== undefined)
            .length > 0
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    async sendOtherbanks(callDocTum) {
      var getData = {};
      let document_group_type = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      if (document_group_type !== undefined) {
        let docCode = document_group_type.lst_doc_id[0];
        let docTypeItem = this.userData.documentType.find(
          (v) => v.doc_code == docCode
        );
        const formData = this.getFormOtherStatement(docTypeItem);
        getData = await this.axiosInstance({
          method: "POST",
          url: "api/saveStatementOtherBank",
          timeout: this.timeout,
          data: formData,
        })
          .catch(() => {
            docTypeItem.state = "error";
            this.forceStateDocumentGroup(docTypeItem.doc_code);
            this.mappingResponseSave(getData, docTypeItem);
            this.$forceUpdate();
          })
          .then(() => {
            this.documentGroup
              .filter((i) => i.state == "uploading")
              .forEach((item) => {
                this.$set(item, "state", "success");
              });
            this.$forceUpdate();
            let document_group_type = this.userData.document_group_type.find(
              (item) =>
                item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
            );
            let docCode = document_group_type.lst_doc_id[0];
            let docTypeItem = this.userData.documentType.find(
              (v) => v.doc_code == docCode
            );

            docTypeItem.filesReal.forEach((file) => {
              this.$set(file, "state", "success");
            });

            console.log("set state success");

            this.$set(docTypeItem, "state", "success");
            this.$forceUpdate();
            this.closeWeb(callDocTum);
          });
      }
    },
    isOtherBanks(documentType) {
      if (
        documentType.filesReal.length > 0 &&
        documentType.filesReal.filter((file) => file.uploadType !== undefined)
          .length > 0
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style scoped>
.row-card-landing {
  padding-left: 14px;
  padding-right: 14px;
}
.body-landing {
  padding-left: 1rem;
  padding-right: 1rem;
}
.progress-bar-custom {
  height: 3px;
  border-radius: unset;
  border-bottom-left-radius: 60px 27px;
  border-bottom-right-radius: 60px 27px;
  margin-left: 2.5px;
  margin-right: 2.5px;
  background-color: unset;
}
.status-color-001 {
  color: #479e6a !important;
}
.status-color-002 {
  color: #df0747 !important;
}
.status-color-003,
.status-color-004 {
  color: #daa60b !important;
}
.status-color-PENDING,
.status-color-RESUBMIT {
  color: #df0747 !important;
}
.status-color-SUBMITED,
.status-color-SUBMITED2,
.status-color-COMPLETE {
  color: #479e6a !important;
}
.badge-wait {
  border: 1.5px solid #f8f8f8 !important;
  box-sizing: border-box;
  color: #cacaca !important;
  background-color: #f8f8f8;
  width: 32px;
  height: 32px;
  margin-left: 1%;
}
.text-danger {
  color: rgb(219, 0, 0);
  font-family: KrungthaiFast-Regular, Arial, sans-serif !important;
  font-size: 16px !important;
}
.text-resubmit {
  color: rgb(212, 150, 74);
  font-family: KrungthaiFast-Regular, Arial, sans-serif !important;
  font-size: 16px !important;
}
</style>
<style>
.text-loan-info {
  color: black !important;
  font-family: KrungthaiFast-Bold, Arial, sans-serif !important;
}
.text-label {
  color: #727a8d !important;
  font-size: 14px;
}
.position-footer {
  position: fixed;
  bottom: 0;
  margin-bottom: 10%;
}
.content-card-sm {
  min-height: 45vh;
}
.content-card-md {
  min-height: 55vh;
}
.btn-loading {
  color: rgb(145, 159, 169) !important;
  background-color: rgb(231, 235, 240) !important;
  border-color: rgb(231, 235, 240) !important;
  background-image: none !important;
}
.swal2-htmlContainer-next-fullscreen {
  font-size: 16px !important;
  margin-bottom: 40vh !important;
  margin-top: 1rem !important;
  line-height: 24px !important;
  height: 50% !important;
}
.swal2-image-next-fullscreen {
  margin-top: 0vh !important;
  margin-bottom: 0vh !important;
}
.swal2-icon {
  border-color: unset !important;
  border: unset !important;
  line-height: 20px !important;
  width: 100% !important;
  margin: 0px !important;
  align-items: unset !important;
}
.swal2-icon-content {
  margin: 0;
  font-family: Kanit-Bold;
  font-size: 20px !important;
  line-height: 24px !important;
  color: #212121 !important;
}
.swal2-modal-next-fullscreen {
  border-radius: 0px !important;
  width: 100% !important;
  padding: 24px !important;
  height: 100vh !important;
  -webkit-animation: unset !important;
  animation: unset !important;
}
.swal2-actions-next-fullscreen {
  display: flex !important;
  justify-content: center !important;
  margin-top: 1rem !important;
  margin-right: 0px !important;
  margin-bottom: 35px !important;
  margin-left: 0px !important;
}
.expired-date-css {
  border-radius: 33px;
  background: rgba(254, 238, 227, 1);
  color: #e17f00 !important;
  font-size: 14px !important;
  line-height: 16px !important;
}
</style>
<style scoped>
.swal2-html-container {
  margin: 1em 1.6em 40vh !important;
}
.icon-loader {
  border: 1px solid rgba(242, 242, 242, 1); /* Light grey */
  border-top: 1px solid rgba(68, 87, 227, 1); /* Blue */
  border-radius: 50%;
  width: 32px;
  height: 32px;
  animation: spin 1s linear infinite;
  position: absolute;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
